import { useCallback } from 'react';
import { useUser } from '~/api/hooks/useGetAccount';
import type { AssistantEventId } from '~/features/assistant/hooks/useAssistant';
import { assistantPersistences } from '~/persistence';
import { getCurrentSeconds } from '~/utils/time';

const ASSISTANT_INTERVAL_DAYS: { [K in AssistantEventId]: number } = {
  '16_birthday': 1,
  birthday: 1,
  client_visit_home_from_cloakroom: 1,
  promising: 1,
  client_swipe_record_growth: 1,
  client_visit_home_from_measure: 1,
  to_measure: 1,
  client_visit_record_growth: 1,
  birthdays_over_11: 182,
  growing: 30,
  grown_up: 2190,
  grown_up_and_retention: 2190,
  month_before_growing_stage: 30,
  month_before_grown_up: 30,
  retention: 1,
  shoe_registration: 1,
};

export const useAssistantInterval = () => {
  const { data: user } = useUser();
  const setAssistantInterval = useCallback(
    (keyId: AssistantEventId) => {
      if (!user) return;
      const currentSeconds = getCurrentSeconds();
      const addSeconds = ASSISTANT_INTERVAL_DAYS[keyId] * 24 * 60 * 60;
      const childId = String(user.selected_child_id);
      const asicsId = String(user.asics_id);
      const initialItems =
        (Array.isArray(assistantPersistences.Interval.value) &&
          assistantPersistences.Interval.value) ||
        [];
      const newItem = {
        child_id: childId,
        asics_id: asicsId,
        event_id: keyId,
        interval: currentSeconds + addSeconds,
      };
      const updatedItems = [
        ...initialItems.filter(
          (item) =>
            !(item.child_id === childId && item.asics_id === asicsId && item.event_id === keyId),
        ),
        newItem,
      ];
      assistantPersistences.Interval.set(updatedItems);
    },
    [user],
  );
  return {
    setAssistantInterval,
  };
};
